import React from 'react';
import { Link } from 'react-router-dom';
import { BOOK } from '../content/book';
import { Section, Eyebrow, SectionHead, Button } from './ui';

/** The book band: cover, title, one line, three buttons. Light. */
const BookPanel = ({ compact = false, eyebrow = 'Out now' }) => (
  <Section tone="card" id="book">
    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
      <div className="md:col-span-4 lg:col-span-3">
        <Link to="/book" className="block max-w-[280px] mx-auto md:mx-0">
          <img src={BOOK.cover} alt={`${BOOK.title}: ${BOOK.subtitle}, by ${BOOK.author}`}
            width="704" height="1106" loading="lazy"
            className="w-full h-auto rounded-md border border-navy-200 dark:border-navy-700 shadow-[0_18px_40px_-24px_rgba(14,22,38,0.45)]" />
        </Link>
      </div>
      <div className="md:col-span-8 lg:col-span-9">
        <Eyebrow>{eyebrow}</Eyebrow>
        <SectionHead>{BOOK.title}: <span className="text-emerald-600 dark:text-emerald-300">{BOOK.subtitle}</span></SectionHead>
        <p className="font-display text-lede mt-4 max-w-[84ch] text-navy-600 dark:text-[#C9D2E0]">
          {BOOK.descriptionLine}
        </p>
        {!compact && (
          <p className="font-sans text-interface mt-3 max-w-[84ch] text-navy-500 dark:text-navy-400">
            By {BOOK.author}. {BOOK.publisher}, {BOOK.publishedText}. {BOOK.pages} pages.
          </p>
        )}
        <div className="mt-7 flex flex-wrap gap-3">
          {BOOK.formats.map((f, i) => (
            <Button key={f.name} href={f.url} variant={i === 0 ? 'primary' : 'secondary'}>
              {f.name} <span className="font-normal opacity-80">{f.price}</span>
            </Button>
          ))}
        </div>
        <div className="mt-5">
          <Link to="/book" className="font-sans text-interface font-medium text-emerald-600 dark:text-emerald-300 hover:text-emerald-500">About the book</Link>
        </div>
      </div>
    </div>
  </Section>
);

export default BookPanel;
